module.exports = __webpack_public_path__ + "img/VillaLoreto_Hotel3.6bbfbb14.jpg";